import { colors, fonts } from '../../../theme';

const styles = {
  // Centered with margins: the transform is used by the slide animation.
  card: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 18,
    width: 'calc(100% - 32px)',
    // On a phone it takes the width minus the 16px margins (358px on an iPhone 15).
    maxWidth: 400,
    mx: 'auto',
    boxSizing: 'border-box',
    pt: '34px',
    px: '22px',
    pb: '14px',
    borderRadius: '18px',
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.surface,
    boxShadow: '0 -12px 40px rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    textAlign: 'center',
    fontFamily: fonts.text,
    color: colors.text,
    outline: 'none',
  },
  // The logo sits astride the top border.
  logoBadge: {
    position: 'absolute',
    top: -26,
    left: '50%',
    ml: '-26px',
    width: 52,
    height: 52,
    boxSizing: 'border-box',
    borderRadius: '50%',
    backgroundColor: colors.background,
    border: `2px solid ${colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    display: 'block',
    width: 28,
    height: 28,
    objectFit: 'contain',
  },
  close: {
    position: 'absolute',
    top: 8,
    right: 8,
    width: 32,
    height: 32,
    fontSize: 18,
    color: colors.textSecondary,
  },
  title: {
    fontFamily: fonts.display,
    fontWeight: 700,
    fontSize: 28,
    lineHeight: 1.1,
  },
  description: {
    fontSize: 13,
    lineHeight: 1.45,
    color: '#D9D9D9',
  },
  openApp: {
    mt: 0.5,
    width: '100%',
    height: 40,
    borderRadius: '10px',
    backgroundColor: colors.text,
    color: colors.background,
    fontFamily: fonts.text,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: colors.text,
    },
  },
  hint: {
    fontSize: 11,
    color: colors.textSubtle,
  },
};

export default styles;
